import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import terminology from 'javascripts/terminology';
import { type CardLayoutModelConstructorType } from '../../types';

export class RollUpInitiativeName extends Field {
  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    if (modelClass.typename === 'Initiative') {
      return { parent: ['name'] };
    }

    return {};
  }

  get title() {
    return `Roll-up ${terminology('initiative')} name`;
  }

  exampleContents(): FieldContentsData {
    return { text: `Example ${terminology('initiative')}` };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.parent?.name };
  }
}
